import React from 'react';

const GradientText = ({ children, className = '', as: Component = 'span' }) => {
  return (
    <Component
      className={`font-bold ${className}`}
      style={{
        color: '#60A5FA',
        textShadow: '0 2px 10px rgba(96, 165, 250, 0.5), 0 0 30px rgba(79, 70, 229, 0.3)',
      }}
    >
      {children}
    </Component>
  );
};

export default GradientText;
